<template>
    <div class="file-uploader-wrapper">
        <drop-zone
            id="dropZone"
            ref="dropZone"
            :options="dropZoneOpts"
            :useCustomSlot="true"
            :include-styling="true"
            @vdropzone-thumbnail="thumbnail"
            @vdropzone-files-added="onFilesAdded"
            @vdropzone-success="onSuccess"
            @vdropzone-removed-file="onFileRemoved"
            @vdropzone-error="onError"
            @vdropzone-queue-complete="onQueueComplete"
            @vdropzone-processing="onProcessing"
        >
            <div class="dropzone-custom-content">
                <slot name="title">Dodaj załączniki</slot>
            </div>
        </drop-zone>
        <slot name="description"></slot>

        <div class="dropzone-submit" v-if="false === dropZoneOpts.autoProcessQueue">
            <button class="btn btn-primary"
                :disabled="busy"
                @click="submit"
            >
                Zapisz
            </button>
        </div>

        <div :class="{ 'uploader-overlay': busy }"></div>
    </div>
</template>

<script>
import DropZone from 'vue2-dropzone'
import { addDynamicEventListener } from '../../services/helpers'
import { template, thumbnail } from '../../services/dropZoneTemplate';
import { merge } from 'lodash';

const THUMBNAIL_HEIGHT = 200;

export default {
    name: 'DropArea',
    components: { DropZone },
    props: {
        clearDropzoneAfterSave: {
            type: Boolean,
            default: false
        },
        dropOptions: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        dropZone() {
            return this.$refs.dropZone
        },

        dropZoneOpts() {
            return merge({
                autoProcessQueue: true,
                maxFilesize: 9,
                createImageThumbnails: true,
                acceptedFiles: 'image/*,application/pdf,.docx,.doc,.xlsx,.xls,.ppt,.pptx',
                thumbnailHeight: THUMBNAIL_HEIGHT,
                previewTemplate: this.template(),
                headers: {
                    'Cache-Control': null,
                    'X-Requested-With': null,
                },
                dictRemoveFile: 'usuń',
            }, this.dropOptions);
        },
    },

    mounted() {
        // click event for download btn
        const self = this
        addDynamicEventListener(
            'click',
            '.file-uploader-wrapper',
            '.dz-filename a',
            function(target) {
                if (target.dataset) {
                    self.$emit('fileDownload', target.dataset.serverUuid)
                }
            }
        )
    },

    methods: {
        template: () => template,
        thumbnail: (file, dataUrl) => thumbnail(file, dataUrl),

        // after drop but not saved yet
        onFilesAdded(files) {
            for (let file of Array.from(files)) {
                this.dropZone.dropzone.emit('complete', file)
            }
        },

        // after save
        onSuccess(file, res) {
            this.$emit('fileSaved', { file, response: JSON.parse(res).data});
            this.dropZone.removeFile(file)
        },

        onFileRemoved(file) {
            if (false === this.clearDropzoneAfterSave) {
                this.$emit('fileDelete', file)
            }
        },

        onError(file, message) {
            this.dropZone.removeFile(file)
            this.$emit('error', message)
        },

        submit() {
            if (this.dropZone.getQueuedFiles().length === 0) {
                return;
            }
            // reveal spinners
            this.dropZone.getQueuedFiles().forEach(file => {
                let progress = file.previewTemplate.querySelector('.dz-processing-status');
                if (progress) {
                    progress.classList.add('dz-processing-on')
                }
            })
            this.busy = true
            this.dropZone.processQueue()
        },

        onProcessing(file) {
            let progress = file.previewTemplate.querySelector('.dz-processing-status');
            if (progress && false === progress.classList.contains('dz-processing-on')) {
                progress.classList.add('dz-processing-on');
            }
        },

        onQueueComplete() {
            this.busy = false
        },
    },

    data: () => ({
        busy: false,
    })
}
</script>

<style scoped></style>
